import moment from 'moment';
import React, { useState } from 'react'

import DaysLeft from './DaysLeft'
import { PLAN } from '../PayWall/utils'
import { TrialExpiredModal, MailTo } from '../../dashboard/shared'

const defaultPlan = {
  id: '',
  expiration: 0,
}

const DaysLeftWrapper = ({ plan = defaultPlan }) => {
  const { id, expiration } = plan
  const [isModalOpen, setIsModalOpen] = useState(false)

  const onClick = () => {
    setIsModalOpen(!isModalOpen)
  }

  if (id === PLAN.trial)
    return (
      <>
        <DaysLeft onClick={onClick} endTime={expiration} />
        {isModalOpen && (
          <TrialExpiredModal isOpen onCancel={onClick} onSubmit={() => {}}>
            <ModalContent plan={plan} />
          </TrialExpiredModal>
        )}
      </>
    )
  return null
}

const ModalContent = ({ plan }) => {
  const isExpired = moment().isAfter(moment.unix(plan.expiration));
  return (
    <p style={{padding: '0 38px'}}>
      {isExpired ? (
        <>
          Your trial period has ended.
          Please purchase a subscription to continue using POPin.
          We offer single creator or enterprise options.
          Click the Start My POPin Subscription button to learn more!
        </>
      ) : (
        <>
          We offer single creator or enterprise options.
          Click the Start My POPin Subscription button to learn more!
        </>
      )}
    </p>
  )
}

export default DaysLeftWrapper
